import { CircularProgress, Stack, Typography } from "@mui/material";

export const ExportLoadingBanner = () => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={2}
      sx={{
        position: "absolute",
        inset: 0,
        zIndex: 10,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        borderRadius: 1,
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="regular" color="text.secondary">
        Export in progress. This may take a moment...
      </Typography>
    </Stack>
  );
};
